import { router, usePathname } from "expo-router";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { setForm } from "@/context/actions/actions";
import { useAppSelector } from "@/context/hooks";
import { storage } from "@/context/storage";
import { sendRequest } from "@/utils/ApiUtil";

export default function OnboardingProvider() {
  const currentRoute = usePathname();
  const globalValues = useAppSelector((state: any) => state);
  const dispatch = useDispatch();

  //Routes that the user can access without the application ID.
  const defaultRotes = [
    "/",
    "/signup",
    "/passwordrecovery",
    "/validate",
    "/welcome",
    "/getready",
    "/approved",
    "/rejected",
    "/documents",
    "/review",
    "/individual/termsandconditions",
    "/corporation/termsandconditions",
  ];

  useEffect(() => {
    const applicationId = storage.getString("user.auth.applicationId");

    //Fetch the application ID if the user for some reason doesn't have it.
    if (
      !currentRoute.startsWith("/home") &&
      !defaultRotes.includes(currentRoute) &&
      !applicationId
    ) {
      fetchApplication();
    }

    //Submit the application when the user is not in the documents page.
    if (currentRoute !== "/documents" && globalValues.applicationReady) {
      submitApplication();
      dispatch(setForm({ applicationReady: false }));
    }
  }, [currentRoute, globalValues.applicationReady]);

  const fetchApplication = async () => {
    try {
      const request = await sendRequest("get", "/applications", null, true);
      const application = request?.application[0];

      storage.set("user.auth.applicationId", application.id);
      storage.set("user.auth.applicationType", application.applicationType);

      if (application?.customerDetailsIndividual?.nationality) {
        dispatch(setForm({ isUSApplication: true }));
      }

      if (application?.status === "READY_FOR_SUBMISSION") {
        fetchApplicationStatus(application.id);
      }
    } catch (error: any) {
      console.error(error);
    }
  };

  const fetchApplicationStatus = async (applicationId: string) => {
    try {
      await sendRequest("get", "/application-status", { applicationId }, true);
    } catch (error: any) {
      console.error(error);
    }
  };

  const submitApplication = async () => {
    const applicationId = storage.getString("user.auth.applicationId");
    try {
      const request = await sendRequest(
        "POST",
        "/submit-application",
        { applicationId },
        true
      );
      if (request) {
        router.replace("/finish");
      }
    } catch (error: any) {
      console.error(error);
    }
  };

  return <></>;
}
